import React, { useState } from 'react'

import api from '../../api'
import ButtonSecondary from '../ui/ButtonSecondary'

import './index.css'

const ChangePassword = (props) => {
  const [ formValues, setFormValues ] = useState({
    oldPassword: '',
    newPassword: '',
    repeatPassword: '',
    isSuccess: false,
  })

  const [ error, setError ] = useState('')
  const [ isLoading, setIsLoading ] = useState(false)

  const updateFields = (e) => {
    setError('')
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    })
  }

  const savePassword = async (e) => {
    e.preventDefault()
    if (formValues.repeatPassword !== formValues.newPassword) {
      return setError('New Passwords don\'t match')
    }
    setError(false)
    setIsLoading(true)
    const response = await api.changeOwnPassword(formValues.oldPassword, formValues.newPassword)
    if (response.data.status === 'failed') {
      setError(response.data.message)
    } else {
      setFormValues({ oldPassword: '', newPassword: '', repeatPassword: '', isSuccess: true })
    }
    setIsLoading(false)
  }

  return (
    <div className="profile-details">
      <h3 className="profile-details__title">Change Password</h3>
      <form className="profile-details__form" autoComplete="off" onSubmit={savePassword}>
        <div className="profile-details__form-group">
          <label className="profile-details__form-label" htmlFor="oldPassword">Old Password</label>
          <input className="profile-details__form-input" id="oldPassword" type="password" value={formValues.oldPassword} name="oldPassword" onChange={updateFields} />
        </div>
        <div className="profile-details__form-group">
          <label className="profile-details__form-label" htmlFor="newPassword">New Password</label>
          <input className="profile-details__form-input" id="newPassword" type="password" value={formValues.newPassword} name="newPassword" onChange={updateFields} />
        </div>
        <div className="profile-details__form-group">
          <label className="profile-details__form-label" htmlFor="repeatPassword">Repeat</label>
          <input className="profile-details__form-input" id="repeatPassword" type="password" value={formValues.repeatPassword} name="repeatPassword" onChange={updateFields} />
        </div>
        <div className="form__error">
          {
            error &&
            <p className="error__text">{error}</p>
          }
        </div>
        <div className="profile-details__form-group profile-details__controls">
          {
            (
              formValues.oldPassword === '' &&
              formValues.newPassword === '' &&
              formValues.repeatPassword === '' &&
              formValues.isSuccess
            )
              ? <p className="success__text">Password Changed</p>
              :
              <ButtonSecondary disabled={error || isLoading} name="Save New Password" className="profile-details__form-submit btn btn--transparent" />
          }
        </div>
      </form>
    </div>
  )
}

export default ChangePassword
